import { createContext } from 'react';

const useFootprintContext = createContext();
export default useFootprintContext;
